/* Фирмена покана за организатора: „Назад към таблото“, „Преглед като гост“ и „Редактирайте поканата“.
   Същите удобни бутони като при сватбените покани, във фирмен вид. */
(function () {
  'use strict';
  var html = document.documentElement;
  if (html.dataset.mode === 'guest') return;

  var T = {
    bg: { back: '← Към таблото', preview: '👁 Преглед', edit: '✎ Редактирайте поканата', note: 'Преглед: така ще я видят гостите' },
    en: { back: '← To the dashboard', preview: '👁 Preview', edit: '✎ Edit the invitation', note: 'Preview: this is what guests will see' }
  };
  function ui() { var b = document.getElementById('enLang'); return b && b.getAttribute('aria-pressed') === 'true' ? 'en' : 'bg'; }
  function viewUrl(view) {
    var url = new URL(location.href);
    url.searchParams.set('view', view);
    url.searchParams.delete('lang');
    url.hash = '';
    return url.toString();
  }

  var back = document.createElement('a');
  back.className = 'fm-nav-back';
  back.href = globalThis.CORPORATE_SESSION && globalThis.CORPORATE_LIVE === 'editor' ? globalThis.CORPORATE_SESSION.pageUrl('tablo') : viewUrl('firmena-tablo');

  var edit = document.createElement('button');
  edit.type = 'button';
  edit.className = 'fm-nav-edit';
  edit.hidden = true;

  var note = document.createElement('p');
  note.className = 'fm-preview-note';
  note.hidden = true;
  note.setAttribute('role', 'status');

  var previewBtn = document.createElement('button');
  previewBtn.type = 'button';
  previewBtn.className = 'fm-nav-preview';
  previewBtn.addEventListener('click', function () {
    if (html.dataset.preview) { exitPreview(); return; }
    var p = document.getElementById('corpPreview');
    if (p) { p.click(); return; }
    var open = document.getElementById('open');
    if (open && !document.getElementById('ticket').classList.contains('open')) open.click();
    enterPreview();
  });

  document.body.append(back, previewBtn, edit, note);
  if (globalThis.CORPORATE_LIVE === 'editor') {
    var saveButton = document.createElement('button');
    saveButton.type = 'button';
    saveButton.className = 'fm-nav-save';
    saveButton.textContent = 'Запази';
    saveButton.addEventListener('click', function () {
      var original = document.getElementById('corpSave');
      if (original && !original.disabled) original.click();
    });
    document.body.appendChild(saveButton);
    function syncSave() {
      var original = document.getElementById('corpSave');
      saveButton.disabled = !original || original.disabled;
      saveButton.textContent = saveButton.disabled ? (ui() === 'en' ? 'Saving…' : 'Запазване…') : (ui() === 'en' ? 'Save changes' : 'Запази');
    }
    new MutationObserver(syncSave).observe(document.getElementById('corporateEditor') || document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});
    ['bgLang','enLang'].forEach(function (id) { var b = document.getElementById(id); if(b) b.addEventListener('click', function(){setTimeout(syncSave,0);}); });
    syncSave();
  }

  function label() {
    var x = T[ui()];
    back.textContent = x.back;
    previewBtn.textContent = html.dataset.preview ? x.edit : x.preview;
    edit.textContent = x.edit;
    note.textContent = x.note;
  }

  function enterPreview() {
    html.dataset.mode = 'guest';
    html.dataset.preview = '1';
    edit.hidden = true;
    previewBtn.textContent = T[ui()].edit;
    note.hidden = false;
    setTimeout(function () { note.hidden = true; }, 4000);
    var ticket = document.getElementById('ticket');
    if (ticket) ticket.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function exitPreview() {
    delete html.dataset.mode;
    delete html.dataset.preview;
    previewBtn.textContent = T[ui()].preview;
    edit.hidden = true;
    note.hidden = true;
    var panel = document.getElementById('fmEditPanel');
    if (panel) panel.open = true;
    var target = panel || document.getElementById('corporateEditor');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Бутонът „Преглед“ в редактора: след неговото действие преминаваме в изглед като гост
  document.addEventListener('click', function (e) {
    if (e.target.closest('#corpPreview')) setTimeout(function () { if (document.getElementById('ticket').classList.contains('open')) enterPreview(); }, 0);
  });
  edit.addEventListener('click', exitPreview);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && html.dataset.preview) exitPreview(); });

  ['bgLang', 'enLang'].forEach(function (id) {
    var b = document.getElementById(id);
    if (b) b.addEventListener('click', function () { setTimeout(label, 0); });
  });
  document.addEventListener('corporate-language', function () { label(); if (typeof syncSave === 'function') syncSave(); });
  label();
})();
